import React, { Fragment, useState, useEffect } from "react";
import { Card, Modal, Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const OrganizerList = () => {
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(""); // "status" or "delete"
    const [selectedOrganizer, setSelectedOrganizer] = useState(null);
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const { getRequest, deleteRequest, putRequest } = useRequests();
    const [searchQuery, setSearchQuery] = useState('');
    const [organizers, setOrganizers] = useState([]);

    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
      });
    
      const resetAlertData = () => {
        setTimeout(() => {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: '',
            message: '',
          }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
      };

      const fetchOrganizers = async () => {
          const response = await getRequest("o-list"); // Replace "users" with the appropriate API endpoint
          if (response && response.code === 200) {
            setOrganizers(response.data);
          } else {
            console.error("Failed to fetch organizers:", response.message);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: 'Failed to fetch organizers',
            }));
          }
          resetAlertData();
          setLoading(false);
        };
      
        useEffect(() => {
          fetchOrganizers();
          if (location.state && typeof location.state.message !== 'undefined') {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: location.state.status,
              message: location.state.message,
            }));
            resetAlertData();
            setLoading(false);
          }
        }, []);
      
        // Filter users based on the search query
    const filteredOrganizer = organizers.filter((organizer) => {
        const email = `${organizer.email}`.toLowerCase();
        const date = `${organizer.created_at}`.toLowerCase();
        const status = `${organizer.status}`.toLowerCase();
        const fullName = `${organizer.first_name} ${organizer.last_name}`.toLowerCase();
        const searchLower = searchQuery.toLowerCase();
    
        return email.includes(searchLower) || fullName.includes(searchLower) || status.includes(searchQuery) || date.includes(searchQuery);
    });
    
    const handleOpenModal = (organizer, type) => {
        setSelectedOrganizer(organizer);
        setModalType(type);
        setShowModal(true);
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
        setModalType("");
        setSelectedOrganizer(null);
      };

    const [isProcessing, setIsProcessing] = useState(false);
      const handleConfirmAction = async () => {
        if (selectedOrganizer) {
          setIsProcessing(true);
          if (modalType === "delete") {
            const response = await deleteRequest(`organizer-delete/${selectedOrganizer.o_id}`);
            if (response && response.code === 200) {
              const updatedOrganizers = organizers.filter((organizer) => organizer.o_id !== selectedOrganizer.o_id);
              setOrganizers(updatedOrganizers);
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'success',
                message: 'Organizer deleted successfully!',
              }));
              resetAlertData();
            } else {
              console.error("Failed to delete organizer:", response?.message);
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'Failed to delete organizer',
              }));
              resetAlertData();
            }
          } else if (modalType === "enable" || modalType === "disable") {
            const newStatus = modalType === "enable" ? "Enable" : "Disable";
            try {
              const jsonpar = JSON.stringify({status: newStatus});
              const response = await putRequest(`organizer-status/${selectedOrganizer.o_id}`, jsonpar);
              if (response && response.code === 200) {
                const updatedOrganizers = organizers.map((organizer) =>
                  organizer.o_id === selectedOrganizer.o_id ? { ...organizer, status: newStatus } : organizer
                );
                setOrganizers(updatedOrganizers);
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'success',
                  message: `Organizer ${newStatus}d successfully`,
                }));
                resetAlertData();
              } else {
                console.error("Failed to update status:", response?.message);
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: `Failed to ${newStatus} organizer.`,
                }));
                resetAlertData();
              }
            } catch (error) {
              console.error("Error updating status:", error);
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'Error updating status',
              }));
              resetAlertData();
            }
          }
          setIsProcessing(false);
          handleCloseModal();
        }
      };
    
      const columns = [
          {
            name: "Organizer Name",
            selector: (row) => `${row.first_name} ${row.last_name}`,
            sortable: true,
          },
          {
            name: "Contact Person",
            selector: (row) => row.contact_person,
            sortable: true,
          },
          {
            name: "Contact Number",
            selector: (row) => row.phone_no,
            sortable: true,
          },
          {
            name: "Email ID",
            selector: (row) => row.email,
            sortable: true,
          },
         
          {
            name: "Status",
            cell: (row) => (
              <button
                onClick={() =>
                  handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")
                }
                className={`btn ${
                  row.status === "Enable" ? "btn-success" : "btn-danger"
                } btn-xxs`}
              >
                {row.status === "Enable" ? "Enable" : "Disable"}
              </button>
            ),
            center: true,
            width: "150px",
          },
          {
            name: "Actions",
            cell: (row) => (
              row.o_id != 1 ? (
                <div className="text-center">
                  <Link
                    className="btn btn-primary btn-xxs me-2"
                    to={`/organizer-edit/${row.o_id}`}
                    title="Edit Organizer"
                  >
                    <i className="fa-regular fa-pen-to-square"></i>
                  </Link>
                  <button
                    className="btn btn-danger btn-xxs"
                    onClick={() => handleOpenModal(row, "delete")}
                    title="Delete Organizer"
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              ) : 
              (
                <div className="text-center">
                  <Link
                    className="btn btn-primary btn-xxs me-2"
                    to={`/organizer-edit/${row.o_id}`}
                    title="Edit Organizer"
                  >
                    <i className="fa-regular fa-pen-to-square"></i>
                  </Link>
                </div>
              )
            ),
            center: true,
            width: "120px",
          }
        ];
      

      const customStyles = {
        header: {
          style: {
            minHeight: "56px",
          },
        },
        headCells: {
          style: {
            color: "#341439",
            fontSize: "17px",
            fontWeight: "600",
            textTransform: "capitalize",
            paddingLeft: "8px", // Adjust padding
            paddingRight: "8px",
          },
        },
        cells: {
          style: {
            fontSize: "16px",
            padding: "12px 9px",
            color: "#7E7E7E",
          },
        },
        pagination: {
          style: {
            fontSize: "16px",
          },
        },
      };

    return (
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w600 mb-0'>Organizer Management</h2>
          {AlertData.message !== "" ? (
            <Snackbars
              variant={AlertData.variant}
              message={AlertData.message}
            />
          ) : (
            ""
          )}
          <Link to='/organizer-add' className='btn btn-rounded btn-primary'>
            Add Organizer
          </Link>
        </div>

        {/* Search input */}
        <div className='mb-4 d-sm-flex d-block justify-content-end'>
          <div style={{position: "relative", width: "18rem"}}>
            <Form.Control
              type='text'
              placeholder='Search...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                fontSize: "18px",
                fontWeight: 500,
                paddingRight: "2rem",
                borderRadius: "0.625rem",
                height: "3.2rem", // Add padding to ensure the icon doesn't overlap text
              }}
            />
            <i
              className='fa fa-search'
              style={{
                position: "absolute",
                right: "10px", // Distance from the right edge of the input
                top: "50%",
                transform: "translateY(-50%)", // Center vertically
                color: "#6c757d", // Optional: color for the icon
                pointerEvents: "none", // Makes sure clicks pass through to the input
              }}
            ></i>
          </div>
        </div>
        <Card>
          <Card.Body>
            {loading ? (
              <div className='text-center'>
                <Spinner animation='border' />
                <p>Loading settings...</p>
              </div>
            ) : (
              <DataTable
                columns={columns}
                data={filteredOrganizer} // Use filtered data
                customStyles={customStyles}
                pagination
                highlightOnHover
                responsive
              />
            )}
          </Card.Body>
        </Card>

        {/* Enable/Disable/Delete Modal */}
        {/* <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === "status"
                            ? selectedOrganizer?.status === "Enable"
                                ? "Disable Organizer"
                                : "Enable Organizer"
                            : "Delete Organizer"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalType === "status" ? (
                        <>
                            Are you sure you want to{" "}
                            {selectedOrganizer?.status === "Enable" ? "disable" : "enable"} the organizer{" "}
                            <strong>{selectedOrganizer?.name}</strong>?
                        </>
                    ) : (
                        <>
                            Are you sure you want to delete the organizer{" "}
                            <strong>{selectedOrganizer?.name}</strong>?
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button
                        className={`btn btn-${modalType === "status"
                            ? selectedOrganizer?.status === "Enable"
                                ? "danger"
                                : "success"
                            : "danger"
                            }`}
                        onClick={handleConfirmAction}
                    >
                        {modalType === "status"
                            ? selectedOrganizer?.status === "Enable"
                                ? "Disable"
                                : "Enable"
                            : "Delete"}
                    </Button>
                </Modal.Footer>
            </Modal> */}

        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {modalType === "enable" && "Enable Organizer"}
              {modalType === "disable" && "Disable Organizer"}
              {modalType === "delete" && "Delete Organizer"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* {modalType === "delete" ? ( */}
            <>
              Are you sure you want to {modalType} the organizer{" "}
              <strong>
                {selectedOrganizer?.first_name} {selectedOrganizer?.last_name}
              </strong>
              ?
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              className={`btn btn-${
                modalType === "enable"
                  ? "success"
                  : modalType === "disable"
                  ? "danger"
                  : "danger"
              }`}
              disabled={isProcessing}
              onClick={handleConfirmAction}
            >
              {modalType === "enable" && "Enable"}
              {modalType === "disable" && "Disable"}
              {modalType === "delete" && "Delete"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
};

export default OrganizerList;
